/**
 * This function joins an array of JSX elements with a specified separator.
 * It ensures that each element is rendered correctly, converting strings to JSX spans if necessary.
 * If the array is empty or contains only falsy values, it returns an empty array.
 * @param _elements
 * @param separator
 * @returns
 */
export function joinJSXElements(_elements: React.ReactNode[], separator: React.ReactNode = " • ") {
	const renderElements: React.ReactNode[] = [];
	const elements = _elements.filter((element) => !!element);
	for (let i = 0; i < elements.length; i++) {
		let element = elements[i];
		if (typeof element === "string") element = <span>{element}</span>;
		if (!(element as any)?.props?.children) continue;
		renderElements.push(element);
		if (i < elements.length - 1 && i >= 0) {
			renderElements.push(separator);
		}
	}
	return renderElements;
}
